import { createAsyncThunk, createSlice } from '@reduxjs/toolkit'
import axios from 'axios'
import { companiesHouseAPI } from '../api/companiesHouseAPI'

export const getCompanyById = createAsyncThunk(
  'companiesHouse/getCompanyById',
  async (companyNumber: any, { rejectWithValue }) => {
    try {
      const response = await companiesHouseAPI.getCompanyById(companyNumber)
      return {
        companyName: response.data.company_name,
        addressLine1: response.data.registered_office_address.address_line_1,
        addressLine2: response.data.registered_office_address.address_line_2,
        town: response.data.registered_office_address.locality,
        county: response.data.registered_office_address.region,
        postCode: response.data.registered_office_address.postal_code,
        country: response.data.registered_office_address.country,
      }
    } catch (err) {
      if (axios.isAxiosError(err)) {
        if (!err.response) {
          throw err
        }
        return rejectWithValue(err.response.data)
      }
    }
  },
)
const companiesHouseSlice = createSlice({
  name: 'companiesHouse',
  initialState: {
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(getCompanyById.rejected as any, (state, action) => {
      if (action.payload) {
        state.error = action.payload.errorMessage
      } else {
        state.error = action.error
      }
    })
  },
})
export default companiesHouseSlice.reducer
